export default function ObjectHelperService() {

  function DIFFERENCE<T>(a: readonly T[] = [], b: readonly T[] = []) {
    let aUniques = a.filter(x => !b.includes(x));
    let bUniques = b.filter(x => !a.includes(x));
    return aUniques.concat(bUniques);
  }

  function hasDifference<T>(a: readonly T[] = [], b: readonly T[] = []) {
    return DIFFERENCE(a, b)?.length > 0;
  }
  function NOT<T>(a: readonly T[] = [], b: readonly T[] = []) {
    return a.filter((value) => b.indexOf(value) === -1);
  }
  function INTERSECT<T>(a: readonly T[] = [], b: readonly T[] = []) {
    return a.filter((value) => b.indexOf(value) !== -1);
  }


  function UNION<T>(a: readonly T[] = [], b: readonly T[] = []) {
    return [...a, ...b];
  }
  function uniqueUNION<T>(a: readonly T[] = [], b: readonly T[] = []) {
    const uniqueUnion: T[] = [...a];

    b.forEach(bElement => {
      if (uniqueUnion.indexOf(bElement) === -1) {
        uniqueUnion.push(bElement);
      }
    });

    // ---
    return uniqueUnion;
  }

  function keyIgnoreCaseCopy<S extends Object, T extends Object>(sourceObj: S, targetObj: T) {

    if (sourceObj) {
      const sourceObjKeys = Object.keys(sourceObj);
      const targetObjKeys = Object.keys(targetObj);

      sourceObjKeys.forEach(sourceObjKey => {
        targetObjKeys.some(targetObjKey => {
          if (targetObjKey.toLowerCase() === sourceObjKey.toLowerCase()) {
            const sourceValue: any = sourceObj[sourceObjKey as keyof S];
            targetObj[targetObjKey as keyof T] = sourceValue;
            return true;
          } else {
            return false;
          }
        });
      });

      return targetObj;
    } else {
      console.warn('source object is empty', sourceObj);
    }

  }

  function arrayToObject<T>(_array: T[], _keyProp: string, _valueProp: string) {

    if (!_array || _array.length <= 0) { return {}; }
    else {
      return _array.reduce((obj: any, item: T) => {
        let key = item[_keyProp as keyof T];
        obj[key] = item[_valueProp as keyof T];
        // ---
        return obj;
      }, {});
    }
  }

  function extractKeys<T>(_mappings: T[]) {
    return Object.keys(_mappings);
  };
  function extractKeysAsNumbers<T>(_mappings: T[]) {
    return extractKeys(_mappings).map((x) => parseInt(x));
  };

  function extractValues<T>(_mappings: T[]) {
    return Object.values(_mappings);
  };

  function createMappings<T, V>(_array: T[], _keyProp: string, _valueProp: string,
    _default?: { key: string, value: V }) {

    if (!_array || _array.length <= 0) { return {}; }
    else {
      return _array.reduce((obj: any, item: T, currentIndex: number) => {

        if (_default && currentIndex === 0) {
          obj[_default.key] = _default.value;
        }

        obj[item[_keyProp as keyof T]] = item[_valueProp as keyof T];

        // ---
        return obj;
      }, {});
    }
  }

  // function getLookupValue<T>(_mappings: T[], _key: string) {
  //   return _mappings[_key];
  // };

  function deepEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) return true; // Handle primitive values and same reference
    if (typeof obj1 !== "object" || typeof obj2 !== "object" || obj1 == null || obj2 == null) {
      return false; // Handle null, undefined, or different types
    }

    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) return false; // Different number of keys

    for (const key of keys1) {
      if (!keys2.includes(key) || !deepEqual(obj1[key], obj2[key])) {
        return false; // Key missing or values not equal
      }
    }

    return true;
  }

  // Use the function
  function areDifferent(obj1: any, obj2: any): boolean {
    return !deepEqual(obj1, obj2);
  }



  // ---
  return {
    NOT, hasDifference, DIFFERENCE, INTERSECT, UNION, uniqueUNION,
    deepEqual, areDifferent,
    keyIgnoreCaseCopy, extractKeys, extractKeysAsNumbers, extractValues, createMappings, arrayToObject,
  }
}